export default __webpack_public_path__ + "static/media/sign-out-light.2c4c7400.svg";